module.exports = __webpack_public_path__ + "img/Weapon_37.a6c31c58.png";